<div class="widget-collab-sites-activities">

  <ng-template #gotoLink>
    <app-action-link [href]="allSiteActivitiesUrl" [target]="'blank'">
      <span i18n="all site activities@@all-site-activities">See all activities</span><i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
    </app-action-link>
  </ng-template>

  <div class="d-none d-md-block float-md-right mt-1"><ng-container *ngTemplateOutlet="gotoLink"></ng-container></div>
  <h2 class="widget-header h4" i18n="collaboration activity header@@collaboration-activity-header">Recent activities</h2>
  <h3 class="text-muted h6" i18n="Latest activities sub header@@latest-activities-sub-header">See what's happening on your SharePoint sites.</h3>
  <div class="d-block d-md-none mt-2 mt-md-0"><ng-container *ngTemplateOutlet="gotoLink"></ng-container></div>

  <div class="collaboration-sites-wrapper" *ngIf="myFrequentSites$ | async as myFrequentSites; else loadingCollabActivities">
    <div class="row">
      <div class="col-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3 mt-4 site-wrapper" *ngFor="let site of myFrequentSites | keyvalue">
        <div class="media mb-3">
          <a href="{{site.key.split(',')[0]}}" title="{{site.key.split(',')[1]}}" class="avatar-link text-uppercase link-contrast-color d-inline-block mr-2 ">
            {{getPreferredNameLetters(site.key.split(',')[1])}}
          </a>
          <h4 class="media-body mb-0">
            <a class="extra-bold link-text-color" href="{{site.key.split(',')[0]}}">{{site.key.split(',')[1]}}</a>
          </h4>
        </div>
        <div *ngFor="let changeItem of site.value">
          <div class="row mb-2">
            <div class="change-item-row">
              <div class="float-left pt-1">
                <ng-container *ngIf="changeItem.UserPhoto$ | async as src; else tempImg">
                  <div role="img" alt="User image" class="rounded-circle ml-3 mr-3 user-img" [ngStyle]="{'background-image': 'url(' + src + ')'}"></div>
                </ng-container>
                <ng-template #tempImg>
                  <div class="letters bg-subtle-color rounded-circle position-relative d-inline-block ml-3 mr-3" title="{{changeItem.Editor}}">
                    <span>{{ getPreferredNameLetters(changeItem.Editor) }}</span>
                  </div>
                </ng-template>
              </div>
              <div class="activities-content">
                <span class="user-name extra-bold pr-1 small">{{changeItem.Editor}}</span>
                <span class="small">{{getChangeType(changeItem.ChangeType)}}{{changeItem.ChangeType === 1 ? 'ed':'d' }} </span>
                <ng-container *ngIf="changeItem.ListItem$; else noListItem">
                  <span class="item-title small extra-bold" *ngIf="changeItem.ListItem$ | async as listItem">
                    <a href="{{listItem.webUrl}}" title="{{listItem.fields.FileLeafRef}}">
                      {{listItem.fields.FileLeafRef.length > 40 ? (listItem.fields.FileLeafRef | slice:0:40) + '...' : (listItem.fields.FileLeafRef) }}
                    </a>
                  </span>
                </ng-container>
                <ng-template #noListItem>
                  <span class="item-title small extra-bold">
                    <a href="{{changeItem.ItemUrl}}" title="{{changeItem.Title}}">
                      {{changeItem.Title.length > 40 ? (changeItem.Title | slice:0:40) + '...' : (changeItem.Title) }}
                    </a>
                  </span>
                </ng-template>
                <div>
                  <span class="text-muted small pt-1 pb-1">{{changeItem.Time | date:'longDate'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="site.value && site.value.length === 0">
          <span class="small" i18n="no recent activities@@no-recent-activities">No recent activities found in SharePoint.</span>
        </div>
      </div>
    </div>
    <div *ngIf="myFrequentSites.length === 0">
      <app-text-placeholder>
        <p i18n="no recent activities@@no-recent-activities">No recent activities found in SharePoint.</p>
      </app-text-placeholder>
    </div>
  </div>
</div>

<ng-template #loadingCollabActivities>
    <div>
        <app-widget-placeholder></app-widget-placeholder>
    </div>
</ng-template>
